/* Eatable – Fall Snacking Trio landing page (etb-*). Vanilla, no deps. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- "Ships in" countdown to the next weekday cutoff (store time zone) ---------- */
  function zonedParts(date, tz) {
    var f = new Intl.DateTimeFormat('en-CA', { timeZone: tz, hour12: false, weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    var p = {};
    f.formatToParts(date).forEach(function (x) { p[x.type] = x.value; });
    return { wd: p.weekday, h: +p.hour % 24, m: +p.minute, s: +p.second };
  }
  function secondsToCutoff(cutoffHour, tz, shipDays) {
    var now = new Date();
    var p = zonedParts(now, tz);
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var today = days.indexOf(p.wd);
    var secsNow = p.h * 3600 + p.m * 60 + p.s;
    for (var add = 0; add < 8; add++) {
      var d = (today + add) % 7;
      if (shipDays.indexOf(d) === -1) continue;
      var diff = add * 86400 + cutoffHour * 3600 - secsNow;
      if (diff > 0) return diff;
    }
    return 0;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initCountdown(root) {
    root.querySelectorAll('[data-etb-countdown]').forEach(function (el) {
      if (el._etbTimer) clearInterval(el._etbTimer);
      var hour = parseFloat(el.dataset.cutoffHour || '14');
      var tz = el.dataset.tz || 'America/Toronto';
      var shipDays = (el.dataset.shipDays || '1,2,3,4,5').split(',').map(Number);
      function tick() {
        var s = Math.max(0, Math.round(secondsToCutoff(hour, tz, shipDays)));
        var h = Math.floor(s / 3600);
        el.textContent = pad(h) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      }
      try { tick(); el._etbTimer = setInterval(tick, 1000); } catch (e) { el.textContent = ''; }
    });
  }

  /* ---------- sticky nav shadow ---------- */
  function initNav(root) {
    var nav = root.querySelector('.etb-nav--sticky');
    if (!nav || nav._etbBound) return;
    nav._etbBound = true;
    var onScroll = function () { nav.classList.toggle('is-stuck', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- generic scroller helpers ---------- */
  function step(track) {
    var first = track.firstElementChild;
    if (!first) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return first.getBoundingClientRect().width + gap;
  }
  function updateArrows(track, prev, next) {
    var max = track.scrollWidth - track.clientWidth - 6;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }
  function bindScroller(scope, trackSel, prevSel, nextSel, opts) {
    var track = scope.querySelector(trackSel);
    if (!track || track._etbBound) return;
    track._etbBound = true;
    var prev = prevSel && scope.querySelector(prevSel);
    var next = nextSel && scope.querySelector(nextSel);
    var loop = opts && opts.loop;
    function go(dir) {
      var max = track.scrollWidth - track.clientWidth - 6;
      if (loop && dir > 0 && track.scrollLeft >= max) { track.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); return; }
      track.scrollBy({ left: dir * step(track), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    if (!loop) {
      track.addEventListener('scroll', function () { updateArrows(track, prev, next); }, { passive: true });
      window.addEventListener('resize', function () { updateArrows(track, prev, next); });
      updateArrows(track, prev, next);
    }
    return go;
  }

  /* ---------- review pills: arrow + gentle autoplay ---------- */
  function initPills(root) {
    root.querySelectorAll('[data-etb-pills]').forEach(function (pills) {
      var go = bindScroller(pills, '[data-etb-pills-track]', '[data-etb-pills-prev]', '[data-etb-pills-next]', { loop: true });
      var ptrack = pills.querySelector('[data-etb-pills-track]'), prevBtn = pills.querySelector('[data-etb-pills-prev]');
      if (ptrack && prevBtn && !ptrack._etbPrev) {
        ptrack._etbPrev = true;
        var syncPrev = function () { prevBtn.hidden = ptrack.scrollLeft <= 2; };
        ptrack.addEventListener('scroll', syncPrev, { passive: true });
        syncPrev();
      }
      if (!go || reduceMotion || pills._etbAuto) return;
      var paused = false;
      pills.addEventListener('mouseenter', function () { paused = true; });
      pills.addEventListener('mouseleave', function () { paused = false; });
      pills.addEventListener('focusin', function () { paused = true; });
      pills.addEventListener('focusout', function () { paused = false; });
      var touched = 0;
      ['click', 'touchstart', 'wheel'].forEach(function (ev) {
        pills.addEventListener(ev, function () { touched = Date.now(); }, { passive: true });
      });
      pills._etbAuto = setInterval(function () {
        if (paused || Date.now() - touched < 8000) return;
        if (document.visibilityState === 'visible' && isInView(pills)) go(1);
      }, 6000);
    });
  }
  function isInView(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  }

  /* ---------- reviews + UGC carousels ---------- */
  function initCarousels(root) {
    root.querySelectorAll('[data-etb-carousel]').forEach(function (c) {
      if (c.hasAttribute('data-etb-loop')) initLoop(c);
      else bindScroller(c, '[data-etb-scroller]', '[data-etb-prev]', '[data-etb-next]');
      /* UGC on mobile opens on the 2nd card, centred, like the design */
      var t = c.querySelector('.etb-ugc__track');
      if (t && !t._etbStart && window.innerWidth < 990 && t.children[1]) {
        t._etbStart = true;
        var card = t.children[1];
        t.scrollLeft = card.offsetLeft - t.offsetLeft - (t.clientWidth - card.offsetWidth) / 2;
      }
    });
  }

  /* Endless carousel: one copy of the slides on each side; when a scroll settles inside a copy,
     jump (invisibly) back to the same slide in the real set. */
  function initLoop(c) {
    var track = c.querySelector('[data-etb-scroller]');
    if (!track || track._etbBound) return;
    track._etbBound = true;
    var prev = c.querySelector('[data-etb-prev]'), next = c.querySelector('[data-etb-next]');
    var slides = [].slice.call(track.children);
    if (slides.length < 2) return;
    function copy(s) {
      var n = s.cloneNode(true);
      n.removeAttribute('data-shopify-editor-block');
      n.setAttribute('aria-hidden', 'true');
      n.setAttribute('inert', '');
      n.setAttribute('data-etb-clone', '');
      return n;
    }
    slides.forEach(function (s) { track.appendChild(copy(s)); });
    slides.slice().reverse().forEach(function (s) { track.insertBefore(copy(s), track.firstChild); });
    function setWidth() { return slides[0].offsetLeft - track.firstElementChild.offsetLeft; }
    function jump(x) {
      track.style.scrollSnapType = 'none';
      track.scrollLeft = x;
      track.offsetHeight;
      track.style.scrollSnapType = '';
    }
    function normalize() {
      var w = setWidth();
      if (!w) return;
      if (track.scrollLeft < w * 0.5) jump(track.scrollLeft + w);
      else if (track.scrollLeft >= w * 1.5) jump(track.scrollLeft - w);
    }
    jump(setWidth());
    var t;
    if ('onscrollend' in window) track.addEventListener('scrollend', normalize);
    else track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(normalize, 160); }, { passive: true });
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      jump(setWidth());
    });
    function go(dir) {
      normalize();
      track.scrollBy({ left: dir * step(track), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
  }

  /* ---------- UGC videos ---------- */
  function initUgc(root) {
    root.querySelectorAll('[data-etb-ugc-video]').forEach(function (btn) {
      if (btn._etbBound) return;
      btn._etbBound = true;
      btn.addEventListener('click', function () {
        var card = btn.closest('.etb-ugc-card');
        var tpl = card && card.querySelector('template');
        if (!tpl) return;
        var media = card.querySelector('.etb-ugc-card__media');
        media.innerHTML = tpl.innerHTML;
        var v = media.querySelector('video');
        if (v) { v.controls = true; v.play().catch(function () {}); }
        card.classList.add('is-playing');
      });
    });
  }

  /* ---------- stockist finder (assets/retailers.json + Leaflet, lazy) ---------- */
  var leafletPromise = null;
  function loadLeaflet(cssUrl, jsUrl) {
    if (window.L) return Promise.resolve(window.L);
    if (leafletPromise) return leafletPromise;
    leafletPromise = new Promise(function (resolve, reject) {
      if (cssUrl && !document.querySelector('link[data-etb-leaflet]')) {
        var l = document.createElement('link');
        l.rel = 'stylesheet'; l.href = cssUrl; l.setAttribute('data-etb-leaflet', '');
        document.head.appendChild(l);
      }
      var s = document.createElement('script');
      s.src = jsUrl; s.async = true;
      s.onload = function () { resolve(window.L); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return leafletPromise;
  }
  function km(a, b, c, d) {
    var R = 6371, p = Math.PI / 180, x = (c - a) * p, y = (d - b) * p;
    var h = Math.sin(x / 2) * Math.sin(x / 2) + Math.cos(a * p) * Math.cos(c * p) * Math.sin(y / 2) * Math.sin(y / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }
  var ABBR = {'Alberta':'AB','British Columbia':'BC','Manitoba':'MB','New Brunswick':'NB','Newfoundland and Labrador':'NL','Nova Scotia':'NS','Northwest Territories':'NT','Nunavut':'NU','Ontario':'ON','Prince Edward Island':'PE','Quebec':'QC','Québec':'QC','Saskatchewan':'SK','Yukon':'YT','Alabama':'AL','Alaska':'AK','Arizona':'AZ','Arkansas':'AR','California':'CA','Colorado':'CO','Connecticut':'CT','Delaware':'DE','Florida':'FL','Georgia':'GA','Hawaii':'HI','Idaho':'ID','Illinois':'IL','Indiana':'IN','Iowa':'IA','Kansas':'KS','Kentucky':'KY','Louisiana':'LA','Maine':'ME','Maryland':'MD','Massachusetts':'MA','Michigan':'MI','Minnesota':'MN','Mississippi':'MS','Missouri':'MO','Montana':'MT','Nebraska':'NE','Nevada':'NV','New Hampshire':'NH','New Jersey':'NJ','New Mexico':'NM','New York':'NY','North Carolina':'NC','North Dakota':'ND','Ohio':'OH','Oklahoma':'OK','Oregon':'OR','Pennsylvania':'PA','Rhode Island':'RI','South Carolina':'SC','South Dakota':'SD','Tennessee':'TN','Texas':'TX','Utah':'UT','Vermont':'VT','Virginia':'VA','Washington':'WA','West Virginia':'WV','Wisconsin':'WI','Wyoming':'WY','District of Columbia':'DC'};
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function initStockists(root) {
    root.querySelectorAll('[data-etb-stockists]').forEach(function (wrap) {
      if (wrap._etbBound) return;
      wrap._etbBound = true;
      var list = wrap.querySelector('[data-etb-stockist-list]');
      var status = wrap.querySelector('[data-etb-stockist-status]');
      var form = wrap.querySelector('[data-etb-stockist-form]');
      var input = form && form.querySelector('input');
      var mapEl = wrap.querySelector('[data-etb-stockist-map]');
      var count = parseInt(wrap.dataset.count || '3', 10);
      var origin = { lat: parseFloat(wrap.dataset.lat), lng: parseFloat(wrap.dataset.lng) };
      var stores = [], map = null, layer = null, started = false;

      function render(items) {
        list.innerHTML = items.map(function (s) {
          var place = [s.city, ABBR[s.state] || s.state].filter(Boolean).join(', ');
          var dist = isFinite(s._d) ? (s._d < 10 ? s._d.toFixed(1) : Math.round(s._d)) + ' km' : '';
          var dest = encodeURIComponent([s.name, s.address_line_1, s.city, s.state, s.postal_code].filter(Boolean).join(', '));
          return '<li class="etb-stockist"><div><p class="etb-stockist__name">' + esc(s.name) + '</p><p class="etb-stockist__meta">' +
            esc(place) + (dist ? '&nbsp; · &nbsp;' + dist : '') + '</p></div><a class="etb-stockist__dir" target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=' +
            dest + '">' + esc(wrap.dataset.dirLabel || 'Directions') + ' →</a></li>';
        }).join('');
      }
      function drawMap(items, center) {
        if (!mapEl || !window.L) return;
        if (!map) {
          map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: false, attributionControl: true });
          L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '&copy; OpenStreetMap' }).addTo(map);
        }
        if (layer) layer.remove();
        layer = L.layerGroup().addTo(map);
        var pts = [];
        items.forEach(function (s, i) {
          var icon = L.divIcon({ className: '', html: '<span class="etb-stockists__pin' + (i === 0 ? ' is-first' : '') + '"></span>', iconSize: [28, 28], iconAnchor: [14, 14] });
          L.marker([s.latitude, s.longitude], { icon: icon, title: s.name }).addTo(layer);
          pts.push([s.latitude, s.longitude]);
        });
        if (pts.length) map.fitBounds(pts, { padding: [36, 36], maxZoom: 13 });
        else if (center) map.setView([center.lat, center.lng], 10);
      }
      function nearest(lat, lng) {
        var sorted = stores.map(function (s) { s._d = km(lat, lng, s.latitude, s.longitude); return s; })
          .sort(function (a, b) { return a._d - b._d; }).slice(0, count);
        render(sorted);
        drawMap(sorted, { lat: lat, lng: lng });
        return sorted;
      }
      function start() {
        if (started) return;
        started = true;
        var data = fetch(wrap.dataset.retailersUrl).then(function (r) { return r.json(); });
        var lib = loadLeaflet(wrap.dataset.leafletCss, wrap.dataset.leafletJs).catch(function () { return null; });
        Promise.all([data, lib]).then(function (res) {
          stores = (res[0].locations || []).filter(function (s) { return isFinite(s.latitude) && isFinite(s.longitude); });
          if (!stores.length) throw new Error('empty');
          nearest(origin.lat, origin.lng);
        }).catch(function () {
          status.textContent = 'Could not load stockists right now. Browse the full list below.';
        });
      }
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var q = (input.value || '').trim();
          if (!q) { input.focus(); return; }
          start();
          status.textContent = 'Searching…';
          fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=ca,us&q=' + encodeURIComponent(q))
            .then(function (r) { return r.json(); })
            .then(function (j) {
              if (!j || !j[0]) { status.textContent = 'No match for “' + q + '”. Try a city or postal / ZIP code.'; return; }
              var go = function () {
                if (!stores.length) { setTimeout(go, 250); return; }
                var res = nearest(+j[0].lat, +j[0].lon);
                status.textContent = res.length ? 'Closest stockists to “' + q + '”' : 'No stockists found near “' + q + '”.';
              };
              go();
            })
            .catch(function () { status.textContent = 'Search is unavailable right now. Please try again.'; });
        });
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); start(); }
        }, { rootMargin: '400px 0px' });
        io.observe(wrap);
      } else { start(); }
    });
  }

  // Flavour cards: swipe carousel below 990px; open on the middle card so both neighbours peek (Figma mobile).
  function initFlavours(root) {
    root.querySelectorAll('.etb-flavours__cards').forEach(function (track) {
      var cards = track.children;
      if (cards.length < 3 || track.scrollWidth <= track.clientWidth) return;
      var mid = cards[Math.floor((cards.length - 1) / 2)];
      track.scrollLeft = mid.offsetLeft - track.offsetLeft - (track.clientWidth - mid.offsetWidth) / 2;
    });
  }

  function init(root) {
    root = root || document;
    initCountdown(root);
    initNav(root);
    initPills(root);
    initCarousels(root);
    initFlavours(root);
    initUgc(root);
    initStockists(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target, track = el.parentElement;
    if (track && track.scrollWidth > track.clientWidth) track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  });
})();
